new Splide( '.splide' ).mount();